import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=48f3a972&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=48f3a972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3a972",
  null
  
)

export default component.exports